import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteFeatureGroupsService = async (
  featureGroupId: string,
): Promise<void> => {
  await jhsfBookingsApi.delete(`/feature-groups/${featureGroupId}`);
};

export default deleteFeatureGroupsService;
